module.exports = __webpack_public_path__ + "static/img/business.947d5b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/company/business.png
// module id = rObb
// module chunks = 2